import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ParcelInformationsComponent } from './components/parcel-informations/parcel-informations.component';
import { ErrorPageComponent } from './components/Shared/error-page/error-page.component';
import { CguComponent } from './components/Shared/footer/cgu/cgu.component';
import { CookiesManagementComponent } from './components/Shared/footer/cookies-management/cookies-management.component';
import { LegalMentionsComponent } from './components/Shared/footer/legal-mentions/legal-mentions.component';
import { PersonnalDataComponent } from './components/Shared/footer/personnal-data/personnal-data.component';
import { environment } from 'src/environments/environment';

const routesNotProd: Routes = [
  { path: 'informations', component: ParcelInformationsComponent },
  { path: 'information_sur_vos_donnees_personnelles', component: PersonnalDataComponent },
  { path: 'mentions_legales', component: LegalMentionsComponent },
  { path: 'gestion_des_cookies', component: CookiesManagementComponent },
  { path: 'conditions_generales_utilisation', component: CguComponent },
  { path: 'ref/:securityCode1/:securityCode2', component: ParcelInformationsComponent },
  { path: '', redirectTo: '/error', pathMatch: 'full'},
  { path: '**', component: ErrorPageComponent },
];

const routesProd: Routes = [
  { path: 'informations', component: ParcelInformationsComponent },
  { path: 'information_sur_vos_donnees_personnelles', component: PersonnalDataComponent },
  { path: 'mentions_legales', component: LegalMentionsComponent },
  { path: 'gestion_des_cookies', component: CookiesManagementComponent },
  { path: 'conditions_generales_utilisation', component: CguComponent },
  { path: 'ref/:securityCode1/:securityCode2', component: ParcelInformationsComponent },
  { path: '', redirectTo: '/error', pathMatch: 'full'},
  { path: '**', component: ErrorPageComponent }  
]

const routes = (environment.production)? routesProd : routesNotProd;
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }